var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dossier-client-app"},[_c('router-view',{attrs:{"dossierCharge":function () { return _vm.dossierCharge = true; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }